import http from './http';

export default {
  async getReviews(numberOfReviews = 10, tagGroup = '') {
    const params = {
      numberOfReviews,
    };
    if (tagGroup) {
      params.tagGroup = tagGroup;
    }
    const response = await http.get('/trustpilot/reviews', {
      params,
    });
    return response ?? [];
  },
};
